import { BodyText, HeadlineText } from "@classdojo/web/nessie";
import { ThemeUIStyleObject, RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { translate } from "@classdojo/web/utils/translate";
import { compose, withHandlers, withState } from "recompose";
import MaterialIcon from "src/shared/components/MaterialIcon";
import toolkitCalloutImage from "src/pods/launchpad/assets/welcome@2x.png";

type WelcomeCalloutProps = {
  hover?: boolean;
  dismissWelcomeNux?: VoidFunction;
  onMouseOut?: VoidFunction;
  onMouseOver?: VoidFunction;
};

function WelcomeCallout({ dismissWelcomeNux, hover, onMouseOut, onMouseOver }: WelcomeCalloutProps) {
  return (
    <div
      sx={{
        ...cardStyle,
        ...(hover && hoverStyle),
      }}
      onMouseOut={onMouseOut}
      onMouseOver={onMouseOver}
      className="welcome-callout"
    >
      <div sx={welcomeContainerStyle}>
        <HeadlineText as="h3" level={2}>
          {translate({
            str: "dojo.toolkit:welcome_callout.title",
            fallback: "Welcome to Toolkit!",
          })}
        </HeadlineText>
        <MaterialIcon icon="close" sx={closeStyle} onClick={dismissWelcomeNux} />
      </div>
      <div sx={contentStyle}>
        <div sx={{ padding: "dt_l", paddingTop: 0 }}>
          <BodyText kind="secondary" sx={pStyle}>
            {translate({
              str: "dojo.toolkit:welcome_callout.explanation",
              fallback: "All your favorite classroom tools are now in one place.",
            })}
          </BodyText>
          <BodyText kind="secondary" sx={{ ...pStyle, marginBottom: "dt_l" }}>
            {translate({
              str: "dojo.toolkit:welcome_callout.call_to_action",
              fallback: "Start a tool from your phone and see it projected in front of the class!",
            })}
          </BodyText>
        </div>
      </div>
    </div>
  );
}

export default compose<WelcomeCalloutProps, WelcomeCalloutProps>(
  withState("hover", "setHover", false),
  withHandlers({
    onMouseOver:
      ({ setHover }) =>
      () =>
        setHover(true),
    onMouseOut:
      ({ setHover }) =>
      () =>
        setHover(false),
  }),
)(WelcomeCallout);

const pStyle: ThemeUIStyleObject = {
  marginTop: "dt_s",
};

const contentStyle: ThemeUIStyleObject = {
  marginRight: RAW_cssValue(105),
};

const welcomeContainerStyle: ThemeUIStyleObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "dt_l",
  paddingBottom: 0,
};

const closeStyle: ThemeUIStyleObject = {
  fontSize: 20,
  color: RAW_cssValue("rgba(44, 47, 66, 0.24)"),
};

const cardStyle: ThemeUIStyleObject = {
  background: `white url('${toolkitCalloutImage}') no-repeat right bottom / auto 156px`,
  display: "flex",
  flexDirection: "column",
  border: "dt_functional",
  boxShadow: "dt_shadow_shadezies",
  borderRadius: "dt_radius_s",
  width: "100%",
  minHeight: 220,
  position: "relative",
};

const hoverStyle: ThemeUIStyleObject = {
  boxShadow: "dt_shadow_shadezies_small",
  cursor: "pointer",
};
